import React, { 
  useEffect,
  useState
} from 'react'
import { 
  FormDataConsumer,
  useGetOne,
  useUpdate,
  useRecordContext
} from 'react-admin';
import StoreMapComponent from "../patron_points_stores_old/MapListMatch";

export default function StoreMap(props) {

  const [infobateCoordinates, setInfobateCoordinates] = useState([0.0, 0.0]);
  const record = useRecordContext()

  const [update] = useUpdate();
  
  const { data } = useGetOne(
      "master_customer_with_coordinates",
      { id: props.id }
  );

  useEffect(() => {
    if (data?.latlon) {
      const _coordinates = data.latlon.replace(/[()]/g, "").split(",");
      const coordinates = [
        parseFloat(_coordinates[0]),
        parseFloat(_coordinates[1]),
      ];

      setInfobateCoordinates(coordinates);
    }
  }, [data]);

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => {        
        return (
        <StoreMapComponent
          {...props}
          fromStoreID={props?.id}
          existingMatchID={formData.patron_point_store_ids || []}
          width={props.width}
          focusMarkerColor="#85BC00"
          possibleMatchMarkerColor="#ED3A2C"
          matchedColor="#982118ad"
          height={250}
          title={"Possible Source Store Matches"}
          name="master_customer_id"
          resourceLocation={'onpoint_patron_points_stores'}
          storeSearchEndpoint="onpoint_find_patron_point_matches"
          storeSearchEndpointID="_master_customer_id"
          focusStoreMarker={infobateCoordinates}
          onChange={(store) => {
            update(      
              "onpoint_master_customers",
              {       
                id: store.infobate_master_customer_id, 
                data: { 
                  patron_points_id: store.id 
                },
                previousData: record
              }
            )
          }}
        />
      )}}
    </FormDataConsumer>
  )
}
